const DASH = "—";

export const money = (value, currency = "INR") => {
  if (value === null || value === undefined) return DASH;
  const n = Number(value);
  if (Number.isNaN(n)) return DASH;
  if (currency === "USD") return `$${n.toFixed(2)}`;
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

export const int = (value) => {
  if (value === null || value === undefined) return DASH;
  const n = Number(value);
  return Number.isNaN(n) ? DASH : n.toLocaleString("en-IN");
};

export const relativeDay = (date, now = new Date()) => {
  if (!date) return DASH;
  const then = new Date(date);
  if (Number.isNaN(then.getTime())) return DASH;
  const days = Math.floor((now - then) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "1d ago";
  return `${days}d ago`;
};

export const freeMeter = (left, limit) =>
  left == null || limit == null ? DASH : `${left} / ${limit}`;

export const MODE_LABEL = {
  charged: "Paid",
  free_tier: "Free tier",
  promotional: "Promo",
};

export const AD_TYPE_LABEL = {
  ctwa: "CTWA",
  lead_form: "Lead form",
  website_to_whatsapp: "Website",
};

export const isVideo = (item = {}) =>
  item.creativeFormat === "video" || Boolean(item.videoUrl);

export const formatLabel = (item = {}) => {
  if (!isVideo(item)) return "Image";
  return item.durationSeconds ? `Video ${item.durationSeconds}s` : "Video";
};

export const share = (part, whole) => {
  const n = Number(whole);
  if (!n) return null;
  return `${Math.round(((Number(part) || 0) / n) * 100)}%`;
};
